export default __webpack_public_path__ + "static/media/logo.f46b887a.svg";